import { typedQueryClient, useTypedQuery } from "hooks";
import { ManufacturerQueryKeys } from "modules/ManufacturerDashboard/queryKeys";
import { MANUFACTURER_STORAGE_KEYS } from "modules/ManufacturerDashboard/storageKeys";
import { PAGE_SIZE, getPreference } from "utils/common";

import type { ManufacturerDashboardFilters } from "modules/ManufacturerDashboard/queryKeys";

export const getManufacturerDashboardInitialFilters = (): ManufacturerDashboardFilters => ({
  mechanic_fixed: getPreference(MANUFACTURER_STORAGE_KEYS.MechanicFixedPreference, null),
  pin_status_id: getPreference(MANUFACTURER_STORAGE_KEYS.PinStatusPreference, null),
  page: 1,
  location_ids: getPreference(MANUFACTURER_STORAGE_KEYS.LocationPreference, []),
  dealer_ids: getPreference(MANUFACTURER_STORAGE_KEYS.DealerPreference, []),
  pin_type_id: getPreference(MANUFACTURER_STORAGE_KEYS.PinTypePreference, []),
  request_status: getPreference(MANUFACTURER_STORAGE_KEYS.RequestStatusPreference, null),
  warranty_type_id: getPreference(MANUFACTURER_STORAGE_KEYS.WarrantyPreference, null),
  search_term: "",
  status: getPreference(MANUFACTURER_STORAGE_KEYS.QuestionStatusPreference, null),
  page_size: PAGE_SIZE.PageSize25
});

export const useManufacturerDashboardFilters = () =>
  useTypedQuery({ queryKey: ManufacturerQueryKeys.dashboardFilters, initialData: getManufacturerDashboardInitialFilters() }).data;

export const setManufacturerDashboardFilters = (newFilters: ManufacturerDashboardFilters) => {
  const filters = typedQueryClient.getQueryData(ManufacturerQueryKeys.dashboardFilters);
  if (!filters) return;

  typedQueryClient.setQueryData(ManufacturerQueryKeys.dashboardFilters, { ...filters, ...newFilters });
};
